import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl, FormArray } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { ModalFichaTecnicaComponent } from '../modal-ficha-tecnica/modal-ficha-tecnica.component';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { Estado } from 'src/app/models/entities/estado';
import { take, concatMap, map } from 'rxjs/operators';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';
import { Usuario } from 'src/app/models/entities/usuario';
import { LevantamientoObra } from 'src/app/models/entities/levantamiento-obra';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';
import { ObraService } from 'src/app/services/obra.service';
import { AlertasService } from 'src/app/services/alertas.service';
import { LevantamientoObraService } from 'src/app/services/levantamiento-obra.service';
import { Obra } from 'src/app/models/entities/obra';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'generador-ficha-planeacion',
  templateUrl: './generador-ficha-planeacion.component.html',
  styleUrls: ['./generador-ficha-planeacion.component.scss']
})
export class GeneradorFichaPlaneacionComponent implements OnInit {

  public fichaTecnicaForm: FormGroup;
  // @Input('tipoObra')
  // public tipoObra: string;
  public estados$: Observable<Estado[]>;
  public suscripcionObras: Subscription;
  public obras: LevantamientoObra[];
  public keyObraSeleccionada: string;
  public datosObra: ObraDTO;
  public usuarioEnSesion: Usuario;
  // public licitaciones$: Observable<any[]>;
  // public fechas$: Observable<any[]>;
  public catTipoCarpetas$: Observable<ElementoCatalogo[]>;
  public catTipoSecciones$: Observable<ElementoCatalogo[]>;
  public catTipoPrioridad$: Observable<ElementoCatalogo[]>;
  public catTipoOrigenRecursos$: Observable<ElementoCatalogo[]>;

  // public urlIframeSanitizada: SafeResourceUrl;
  // public urlIframe: string;
  public mostrarMapaIframe: boolean = false;
  // public rutasFotosFull: any[] = [];
  // public rutasFotosAvance: any[] = [];
  // public rutasFotosEstructura: any[] = [];
  // public rutasFotosProblematica: any[] = [];

  public date: Date = new Date();
  public TIPO_OBRA_PLANEACION: string = '1';

  @ViewChild('modalFichaTecnica')
  public modalFichaTecnica: ModalFichaTecnicaComponent;

  @ViewChild('modalFichaTecnicaCapturada')
  public modalFichaTecnicaCapturada: any;
  public modalActivo: NgbModalRef;


  constructor(
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private levantamientoObraService: LevantamientoObraService,
    private catalogoService: CatalogoService,
    private obraService: ObraService,
    private facadeSesionService: FacadeSesionService,
    private alertasService: AlertasService,
    private modalService: NgbModal
  ) { }

  public ngOnInit(): void {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad('Generar obra en planeación');
    this.facadeSesionService.usuarioEnSesionService.obtenerUsuario().subscribe(
      (usuarioSesionDTO: UsuarioSesionDTO) => this.usuarioEnSesion = usuarioSesionDTO.usuario
    );
    this.inicializarFichaTecnicaForm();
    this.obtenerCatalogoEstados();
  }



  private inicializarFichaTecnicaForm(): void {
    this.fichaTecnicaForm = this.formBuilder.group({
      estado: new FormControl('-1', [Validators.required, this.validateId]),
      keyLevantamientoObra: new FormControl('-1', [Validators.required, this.validateId]),
      licitacion: new FormControl('-1', [Validators.required, this.validateId]),
      fecha: new FormControl('-1', [Validators.required, this.validateId]),
      fechaActualizacion: new FormControl((this.date).getTime()),
      keyCatTipoPrioridad: new FormControl('-1', [Validators.required, this.validateId]),
      keyCatOrigenRecursos: new FormControl('-1', [Validators.required, this.validateId]),
      caracteristicas: new FormControl('', [Validators.required]),
      tpda: new FormControl('', [Validators.required]),
      keyCatCarpeta: new FormControl('-1', [Validators.required, this.validateId]),
      keyCatSeccion: new FormControl('-1', [Validators.required, this.validateId]),
      periodoEjecucion: new FormControl('', [Validators.required]),
      longitudTotal: new FormControl('', [Validators.required]),
      inversionTotal: new FormControl('', [Validators.required]),
      esquemaFinanciamiento: new FormControl('', [Validators.required]),
      registroSHCP: new FormControl('', [Validators.required]),
      estatusSHCP: new FormControl('', [Validators.required]),
      proyectoEjecutivo: new FormControl('', [Validators.required]),
      liberacionDerechoVia: new FormControl('', [Validators.required]),
      cus: new FormControl('', [Validators.required]),
      mia: new FormControl('', [Validators.required]),
      avanceFisicoGlobal: new FormControl('', [Validators.required]),
      avanceFinancieroGlobal: new FormControl('', [Validators.required]),
      observaciones: new FormControl('', [Validators.required]),
      problematica: new FormControl('', [Validators.required]),
      beneficios: new FormControl('', [Validators.required]),
      proximasAcciones: new FormControl('', [Validators.required]),
      incluyeImagenes: new FormControl(true),
      keyUsuario: new FormControl(this.usuarioEnSesion.key),
      ejerciciosFiscales: this.formBuilder.array([this.crearFormEjercicioFiscal()]),
    });

    this.fichaTecnicaForm.get('keyLevantamientoObra').disable();
    this.fichaTecnicaForm.get('licitacion').disable();
    this.fichaTecnicaForm.get('fecha').disable();

    this.fichaTecnicaForm.get('estado').valueChanges.subscribe(
      (keyEstado: string) => {
        if (keyEstado === '-1') {
          this.fichaTecnicaForm.get('keyLevantamientoObra').disable();
          this.fichaTecnicaForm.get('licitacion').disable();
          this.fichaTecnicaForm.get('fecha').disable();

          this.fichaTecnicaForm.get('keyLevantamientoObra').setValue('-1');
          this.fichaTecnicaForm.get('licitacion').setValue('-1');
          this.fichaTecnicaForm.get('fecha').setValue('-1');

          this.mostrarMapaIframe = false;
        } else {
          this.fichaTecnicaForm.get('keyLevantamientoObra').enable();
          this.fichaTecnicaForm.get('keyLevantamientoObra').setValue('-1');
          this.suscripcionObras = this.levantamientoObraService.findAprobadosByKeyEstadoAndTipoObra(keyEstado, this.TIPO_OBRA_PLANEACION).pipe((take(1))).subscribe(
            (levantamientoObra: LevantamientoObra[]) => {
              this.obras = levantamientoObra;
            }
          );
        }
      }
    );

    this.fichaTecnicaForm.get('keyLevantamientoObra').valueChanges.subscribe(
      async (keyObra: string) => {
        if (keyObra === '-1') {
          this.mostrarMapaIframe = false;
        } else {
          let obraValidar = await this.obraService.findByKeyLevantamientoObra(keyObra).pipe(take(1)).toPromise();
          if (obraValidar == null) {
            this.obtenerCatalogos();
            this.mostrarMapaIframe = true;
          } else {
            this.abrirModal();
            this.mostrarMapaIframe = false;
          }
          // let estadoKey: string = this.fichaTecnicaForm.get('estado').value;
          // let obraKey: string = this.fichaTecnicaForm.get('keyLevantamientoObra').value;
          // let licitacionKey: string = this.fichaTecnicaForm.get('licitacion').value;
          // let fecha: string = this.fichaTecnicaForm.get('fecha').value;
          // this.urlIframe = `https://sctsupervision-1527449638423.firebaseapp.com/Supervision1.0/Mapa_01.html?a=${estadoKey}&b=${obraKey}&c=${licitacionKey}&d=${fecha}`;
          // this.urlIframeSanitizada = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlIframe);
          // this.appMovilService.obtenerRutasFotosFull(estadoKey, obraKey, licitacionKey, fecha).subscribe(
          //   rutasFotosFull => {
          //     rutasFotosFull.forEach((ruta, index) => {
          //       ruta.ruta.subscribe(
          //         ruta => {
          //           this.rutasFotosFull.push({ ruta: ruta, descripcion: rutasFotosFull[index].descripcion });
          //         }
          //       )
          //     });
          //   }
          // );
          // this.appMovilService.obtenerRutasFotosAvance(estadoKey, obraKey, licitacionKey, fecha).subscribe(
          //   rutasFotosAvance => {
          //     rutasFotosAvance.forEach((ruta, index) => {
          //       ruta.ruta.subscribe(
          //         ruta => {
          //           this.rutasFotosAvance.push({ ruta: ruta, descripcion: rutasFotosAvance[index].descripcion });
          //         }
          //       )
          //     });
          //   }
          // );
          // this.appMovilService.obtenerRutasFotosEstructura(estadoKey, obraKey, licitacionKey, fecha).subscribe(
          //   rutasFotosEstructura => {
          //     rutasFotosEstructura.forEach((ruta, index) => {
          //       ruta.ruta.subscribe(
          //         ruta => {
          //           this.rutasFotosEstructura.push({ ruta: ruta, descripcion: rutasFotosEstructura[index].descripcion });
          //         }
          //       )
          //     });
          //   }
          // );
          // this.appMovilService.obtenerRutasFotosProblematica(estadoKey, obraKey, licitacionKey, fecha).subscribe(
          //   rutasFotosProblematica => {
          //     rutasFotosProblematica.forEach((ruta, index) => {
          //       ruta.ruta.subscribe(
          //         ruta => {
          //           this.rutasFotosProblematica.push({ ruta: ruta, descripcion: rutasFotosProblematica[index].descripcion });
          //         }
          //       )
          //     });
          //   }
          // );
        }
      }
    );
  }

  public validarCheck(checkValue: boolean) {
    if (!checkValue) {
      this.fichaTecnicaForm.get('incluyeImagenes').setValue(0);
    }
  }

  public guardarFormato(obra): void {
    this.obraService.save(obra).then(
      () => { this.alertasService.mostrarAlerta('success',"Obra guardada correctamente.") }
    );
    this.limpiarFormularioFichaTecnica();
  }

  public crearFormEjercicioFiscal(): FormGroup {
    return this.formBuilder.group({
      letrasEsquemaFiscal: new FormControl(''),
      esquemaFiscal: new FormControl(''),
      letrasAsignacion: new FormControl(''),
      asignacion: new FormControl(''),
      letrasMeta: new FormControl(''),
      meta: new FormControl('')
    });
  }

  public agregarEjercicioFiscal(): void {
    (this.fichaTecnicaForm.get('ejerciciosFiscales') as FormArray).push(this.crearFormEjercicioFiscal());
  }

  public eliminarEjercicioFiscal(indice: number): void {
    (<FormArray>this.fichaTecnicaForm.controls.ejerciciosFiscales).removeAt(indice);
  }

  public obtenerCatalogoEstados(): void {
    this.estados$ = this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(take(1));
  }

  public obtenerCatalogos(): void {
    this.catTipoCarpetas$ = this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CARPETAS).pipe(take(1));
    this.catTipoSecciones$ = this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SECCIONES).pipe(take(1));
    this.catTipoPrioridad$ = this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.PRIORIDAD).pipe(take(1));
    this.catTipoOrigenRecursos$ = this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.ORIGEN_RECURSOS).pipe(take(1));
  }

  private validateId(control: AbstractControl) {
    return control.value === '-1' ? { error: 'El campo es requerido' } : null;
  }

  public limpiarFormularioFichaTecnica(): void {
    this.fichaTecnicaForm.reset();
    this.inicializarFichaTecnicaForm();
  }

  public generarFichaTecnica(): Promise<Obra> {
    return new Promise((resolve, reject) => {
      let obra: Obra = this.crearModeloFichaTecnica(this.fichaTecnicaForm.value);
      resolve(obra);
    });
    //   let estadoKey: string = this.fichaTecnicaForm.get('estado').value;
    //   let obraKey: string = this.fichaTecnicaForm.get('obra').value;
    //   let licitacionKey: string = this.fichaTecnicaForm.get('licitacion').value;
    //   let fecha: string = this.fichaTecnicaForm.get('fecha').value;
    //   this.appMovilService.obtenerFechasConCoordenadas(estadoKey, obraKey, licitacionKey, fecha).subscribe(
    //     (fechas: any[]) => {
    //       let googlePolyline: GooglePolyline = this.construirPolyline(fechas);
    //       googlePolyline.color = "#0000ff";
    //       let fichaTecnica: FichaTecnica = this.crearModeloFichaTecnica(this.fichaTecnicaForm.value, googlePolyline);
    //       resolve(fichaTecnica);
    //     },
    //     error => {
    //       console.error("Error al obtener fechas para generar url del mapa.", error);
    //       reject();
    //     }
    //   );
    // });
  }

  public crearModeloFichaTecnica(fichaTecnicaDeForm: any): Obra {
    let obra: Obra = Object.assign(fichaTecnicaDeForm) as Obra;
    return obra;
  }

  public abrirModalFichaTecnica(): void {
    this.generarFichaTecnica()
      .then(async (obra: Obra) => {
        this.datosObra = await this.levantamientoObraService.findByKey(obra.keyLevantamientoObra).pipe(
          take(1),
          concatMap((levantamientoObra: LevantamientoObra) => this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(
            take(1),
            map((estados: Estado[]) => {
              let estado: Estado = estados.find((estado: Estado) => estado.key === levantamientoObra.keyCatEstado);
              return {
                nombreEstado: estado.nombre,
                nombreObra: levantamientoObra.nombreObra,
                nombreTramoLicitacion: levantamientoObra.nombreTramoLicitacion,
                obra
              } as ObraDTO;
            })
          )),
          take(1),
        ).toPromise();
        this.modalFichaTecnica.abrirModal(this.datosObra);
      })
      .catch(() => {
        console.error("Error al mapear datos de la obra.");
      })
      .finally(() => {

      });
  }

  public guardarFicha(): void {
    this.generarFichaTecnica()
      .then((obra: Obra) => {
        this.guardarFormato(obra);
      })
      .catch(() => {
        console.error("Error al generar ficha técnica.");
      })
      .finally(() => {

      });
  }

  public getErrorFicha(controlName: string): string {
    let error = '';
    const control = this.fichaTecnicaForm.get(controlName);
    if (control.touched && control.errors != null) {
      error = "El campo es requerido";
    }
    return error;
  }

  public abrirModal(): void {
    this.modalActivo = this.modalService.open(this.modalFichaTecnicaCapturada, { centered: true, size: 'lg', windowClass: 'modal-confirmacion' });
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public ngOnDestroy(): void {
    if (this.suscripcionObras) {
      this.suscripcionObras.unsubscribe();
    }
  }

}